export default {
  "app": {
    "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["光夜小工具"])},
    "documentTitle": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list, linked: _linked, type: _type } = ctx;return _normalize([_interpolate(_list(0)), " - ", _linked("app.title", undefined, _type)])}
  },
  "route": {
    "changelog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更新日志"])},
    "cpr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["礼包性价比计算器"])},
    "gacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信使花园模拟器"])},
    "hoard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["囤囤鼠计算器"])},
    "home": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["首页"])},
    "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["欧皇模拟器"])},
    "item": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["道具合成计算器"])},
    "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵犀养成计算器"])},
    "notfound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["404 Not Found"])},
    "phone": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["手机模拟器 [WIP]"])},
    "statement": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关于与声明"])},
    "wish": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["羁梦星愿计算器"])},
    "wishsim": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["羁梦花事模拟器"])}
  },
  "settings": {
    "mirror": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["镜像"])},
    "mirrorDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不同镜像的内容完全一致，若您访问某一镜像速度较慢，可选择切换到另一镜像。"])},
    "cache": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["缓存"])},
    "clearCacheDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除缓存后，一些设置项将回到默认值。"])},
    "clearLocalStorage": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除 localStorage"])},
    "clearLocalStorageToast": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["localStorage 已清空。"])},
    "appearance": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外观"])},
    "appearances": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["光"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["夜"])},
      
    ],
    "appearanceDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["若您的设备不支持切换亮 / 暗色模式，可在此手动切换。"])},
    "about": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关于"])},
    "addtohome": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加到主屏幕"])},
    "addtohomeDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具已 PWA 化，使用以下方法将本工具添加到主屏幕，在下载所有资源后，即可作为 APP 离线使用。其他方法均不作推荐，也不在此介绍。"])},
    "addtohomeAndroid": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["请使用 Google Chrome 浏览器打开本工具，点击右上方的 ", _interpolate(_list(0)), " 按钮，选择「添加到主屏幕」。"])},
    "addtohomeIos": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named } = ctx;return _normalize(["请使用 Safari 浏览器打开本工具，点击下方的 ", _interpolate(_named("share")), " 按钮，选择「 ", _interpolate(_named("add")), " 添加到主屏幕」。"])},
    "version": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["最后更新于"])},
    "developer": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开发人员选项"])},
    "lang": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["语言"])},
    "server": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["服务器"])},
    "vConsole": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["vConsole"])},
    "lab": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["实验性功能"])}
  },
  "common": {
    "announce": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["公告"])},
    "announceNoMore": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不再提醒"])},
    "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["返回"])},
    "calculate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["计算"])},
    "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清空"])},
    "currentStatus": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前状态"])},
    "customize": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自定义"])},
    "detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["详情"])},
    "equalsTo": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["折合为", _interpolate(_list(0))])},
    "eventEnd": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["止"])},
    "eventStart": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["始"])},
    "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除"])},
    "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["说明"])},
    "gacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["抽卡"])},
    "loading": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 加载中…"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["名称"])},
    "notfound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["似乎走错路了……"])},
    "percentage": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "%"])},
    "result": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["结果"])},
    "selected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已选"])},
    "settings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设置"])},
    "tutorial": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["攻略"])}
  },
  "pwa": {
    "cached": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["缓存成功，可供离线使用。"])},
    "updatefound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["正在下载新内容……"])},
    "updated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["更新成功，点击刷新页面缓存。"])}
  },
  "characters": [
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["萧逸"])},
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["陆沉"])},
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["齐司礼"])},
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["夏鸣星"])},
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查理苏"])},
    (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["蓝星"])},
    
  ],
  "items": {
    "100003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小熊星座"])},
    "100011": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["羽毛笔"])},
    "100012": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["十连签收券"])},
    "100013": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["心迹书简"])},
    "100030": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星旅币"])},
    "100073": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["光影留痕"])},
    "110003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵感结晶"])},
    "120001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初心"])},
    "120002": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["慕心"])},
    "120003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["恋心"])},
    "200011": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一级材料"])},
    "200012": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二级材料"])},
    "200013": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["三级材料"])},
    "200102": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设计助理证明"])},
    "200103": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["初级设计师证明"])},
    "200104": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设计师证明"])},
    "200105": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["资深设计师证明"])},
    "200106": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["创意总监证明"])},
    "230001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["眩光沙砾"])},
    "231001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["稀愿珍宝"])},
    "231002": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["心愿海螺"])},
    "300013": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["羽色缎带"])},
    "300395": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["霜白书简"])},
    "300401": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["镜中身影"])},
    "300402": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星愿瓶"])},
    "301030": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["甜心书简"])},
    "301152": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回忆书简"])},
    "400000": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合欢书简"])},
    "400001": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["青石"])},
    "400002": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["坚木"])},
    "400003": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["琳琅券"])},
    "coin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["极光币"])},
    "flower": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵感"])},
    "star": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["北极星"])}
  },
  "hint": {
    "cpr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此工具仅计算礼包用于抽卡的性价比，游戏中显示的性价比计入了极光币等培养材料。\n\n不氪立省百分百。"])},
    "cprStarRatio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本游戏中，抽卡道具的原价为：\n\n1 羽毛笔 = 300 小熊星座 = 6 北极星 = 18 元\n\n北极星与其他道具的兑换比率不固定，因此计算性价比时需要分不同情况讨论。\n\n根据您一般使用北极星兑换小熊星座的途径，选择恰当的兑换比率。\n\n如果还是不明白选什么：重氪选 [50]，其他选 [100]。"])},
    "events": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本页展示当前游戏中，各活动的大约开始或结束时间。\n\n因为活动结束常常伴随停服维护，结束时间按 00:00 而非 04:59 计。\n\n信息可能过时或不准确，请以游戏中实际情况为准。"])},
    "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["使用「方正准雅宋 GBK」字体需要获得授权，其中「个人非商业授权」可按照以下步骤免费获得：\n\n1. 登陆方正字库官网，阅读并同意相关许可协议。\n2. 在「方正雅宋家族」页面的「字体样式」下找到「方正准雅宋」，点击它右侧的「获取字体」。\n3. 点击右侧浮动菜单中的「清单 - 字体清单」。\n4. 在弹出的页面中，将「字符集」改为「繁简扩展 (GBK)」，然后点击右下角的「获得字体」。\n5. 再次确认后，即可在「我的字体」中找到「下载字体」。\n\n下载字体并安装后，重新启动浏览器，一般就可以正常调用该字体。"])},
    "gacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具抽卡机制与游戏中不完全相同，仅作娱乐之用。\n\n返回并重新进入本页面即可重置数据。"])},
    "gachaWaterLevel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["水位即连续未得到 6 星的抽卡次数。在水位达到 60 后，6 星出率将随水位增加而增加。\n\n- 常驻卡池「浮世同行」不同版本之间共享水位；\n- 轮换卡池「浮世同行・剪影」之间共享水位；\n- 主线卡池「时间的彼岸」系列中，若连续开启两个卡池，则前一个卡池的水位能够继承到下一个卡池。\n\n除了以上情况外，卡池间不共享水位。"])},
    "gachaBuyCommon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["截止目前，新加入常驻卡池的 5、6 星灵犀还没有开启书简兑换的记录。"])},
    "gachaPossibility": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自连续不出 6 星的第 60 抽起，每抽都会增加 6 星 10% 的出率，直到抽到 6 星、出率恢复为 2% 为止。十连收信必出 5 星或以上灵犀。"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果对 5 星卡不感兴趣，或者水位大于 51，建议用单抽代替十连。"])},
      
    ],
    "hoard": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["此工具在计算过程中，所有项目均按照「奖励在第一天发放」的规则参与计算，与实际情况存在偏差。\n\n目标日期越远，因奖励发放时间产生的偏差所占比例减小，计算结果相对更加准确；但同时活动等不确定因素也增多。\n\n出于上述原因，本工具仅供粗略计算之用。"])},
    "wishsim": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["由于官方未公示该活动概率具体计算规则，本工具中使用的概率数据是由面积比例估算而来，与实际情况不符。\n\n本工具默认假设：\n- 「恋心」占有 166 的权重；\n- 「眩光沙砾」占有 145 的权重；\n- 其他奖励均占有 100 的权重。\n所得到的概率数值与已记录的实际数值稍有偏差。如果您有更好的权重数据，可在此处更改。"])}
  },
  "tutorial": {
    "via": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["来自 ", _interpolate(_list(0)), "。", _interpolate(_list(1))])},
    "messager": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["@", "光与夜之恋信使攻略站"])},
    "cpr": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["常驻礼包性价比"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/Lg2v1rjG8"])},
      (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
      
    ],
    "gacha": [
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LbPP0AlN8"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LcrUctQEB"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LcIFtaXwt"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/Lmq1jEYXe"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/Lw0gD1Qab"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LApMPoGKJ"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据分析与抽卡心得"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LEm1w9sxC"])},
        (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
        
      ],
      
    ],
    "hoard": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["签到活动汇总"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/Lp8uxiSt3"])},
      (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
      
    ],
    "wish": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「羁梦星愿」攻略"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["https://weibo.com/2304898581/LgDLGeIYw"])},
      (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("tutorial.messager", undefined, _type)])},
      
    ]
  },
  "changeLog": {
    "version": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 年第 ", _interpolate(_list(1)), " 周"])},
    "versionNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "w", _interpolate(_list(1))])},
    "features": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["功能与改进"])},
    "updates": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数据更新"])},
    "bugfixes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["问题修复"])},
    "deprecated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["失效或移除"])}
  },
  "cpr": {
    "ratio": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["北极星兑换比率"])},
    "ratios": {
      "150": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动十连特惠（20 北极星十连，部分活动出现）"])},
      "100": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本月十连特惠、今日星座专享"])},
      "71": {
        "33": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["福袋（平均值，部分活动出现）"])}
      },
      "50": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["原价兑换"])}
    },
    "ratioNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["1 北极星 = ", _interpolate(_list(0)), " 小熊星座"])},
    "detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["礼包详情"])},
    "nameDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["显示在列表中，方便识别用。"])},
    "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["售价"])},
    "priceUnit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¥"])},
    "gachaCount": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["包含抽数"])},
    "gachaCountNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 抽"])},
    "cpr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["性价比"])},
    "cprNumber": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("common.percentage", undefined, _type)])},
    "pricePerGacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每抽价格"])},
    "pricePerGachaNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "¥"])},
    "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["加入列表"])},
    "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清除当前输入"])},
    "list": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["列表"])},
    "tutorial": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["礼包名称"])},
      "cpr": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("cpr.cpr", undefined, _type)])},
      "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["点击以选择，左滑以删除"])}
    },
    "selected": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已选中礼包总体"])},
    "noSelect": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未选中"])},
    "result": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["¥", _interpolate(_list(0)), " = ", _interpolate(_list(1)), " 抽 (", _interpolate(_list(2)), " 元/抽)"])},
    "toast": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入名称。"])},
      "price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入售价。"])},
      "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请输入礼包内容。"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已加入列表。"])}
    }
  },
  "gacha": {
    "tabbar": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信使花园"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收信记录"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵犀统计"])},
      (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("common.settings", undefined, _type)])},
      
    ],
    "pool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卡池"])},
    "poolName": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " [", _interpolate(_list(1)), "]"])},
    "poolYear": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 年"])},
    "poolType": {
      "common": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["常驻卡池"])},
      "limited": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定卡池"])}
    },
    "cardName": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "・", _interpolate(_list(1))])},
    "cardNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 花"])},
    "choosePool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择卡池"])},
    "commonPool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["浮世同行"])},
    "desc": {
      "cardStar": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["[", _interpolate(_list(0)), " 星] "])},
      "cardName": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "、"])},
      "up": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 将获得 ", _interpolate(_list(1)), "% 概率 UP。"])},
      "addCommon": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 也将加入卡池但不享受概率 UP。"])},
      "noShop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["以上灵犀将不会额外开放书简兑换。"])},
      "add": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["当日维护更新后，", _interpolate(_list(0)), " 加入所有卡池常驻。"])},
      "inherit": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["该卡池的水位将能够继承到「", _interpolate(_list(0)), "」中。"])},
      "limitedLetter": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["该卡池中，每次收信将额外获得「", _interpolate(_list(0)), "」而非「心迹书简」。"])},
      "randomTime": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["累计收信 ", _interpolate(_list(0)), " 次，将随机获赠一张限定灵犀。"])},
      "pickTime": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["累计收信 ", _interpolate(_list(0)), " 次，可自选一张限定灵犀。"])},
      "pickPrice": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["使用 ", _interpolate(_list(0)), " 枚「", _interpolate(_list(1)), "」可兑换一张自选限定灵犀。"])}
    },
    "star": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 星"])},
    "stars": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["★★★★★★"])},
    "waterLevel": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["水位"])},
    "star6Possibility": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["6 星出率"])},
    "possibilityTitle": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星级"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前出率"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已抽取"])},
      
    ],
    "gachaTime": {
      "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["总抽数"])},
      "pool": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前卡池抽数"])},
      "number": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " + 10 × ", _interpolate(_list(1)), " = ", _interpolate(_list(2))])}
    },
    "buy": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换"])},
      "common": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换常驻灵犀"])},
      "limited": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换限定灵犀"])},
      "pick": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换自选灵犀"])},
      "price": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 星 (", _interpolate(_list(1)), " ", _interpolate(_list(2)), ")"])},
      "time": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 次收信"])}
    },
    "notify": {
      "failure": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "不足。"])},
      "pickFailure": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["抽数不足。"])},
      "success": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换成功。"])}
    },
    "gacha": {
      "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收取一次"])},
      "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收取十次"])}
    },
    "tag": {
      "single": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["单抽"])},
      "shop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["兑换"])},
      "pick": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["自选"])},
      "random": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["随机"])}
    },
    "settings": {
      "animation": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["收信动画"])},
      "animations": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不启用动画"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["动画样式 1"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["动画样式 2"])},
        
      ],
      "shining": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发光效果"])},
      "allchar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不限男主"])},
      "allstar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["不限星级"])}
    }
  },
  "hoard": {
    "card": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["月卡"])},
    "cardDesc": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "/", _interpolate(_list(1)), "・", _interpolate(_list(2)), "・", _interpolate(_list(3))])},
    "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等级"])},
    "decline": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["过期时间"])},
    "itemDesc": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "・", _interpolate(_list(1))])},
    "other": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其他"])},
    "otherDesc": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["其他每", _interpolate(_list(0)), "固定获得的小熊星座"])},
    "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目标日期"])},
    "resultGacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["预计可攒到抽数"])},
    "dateFormat": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["M 月 D 日 (", _interpolate(_list(0)), ")"])},
    "defaultRemain": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["一个月后"])},
    "remain": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["余 ", _interpolate(_list(0)), " 天"])}
  },
  "home": {
    "tabbar": {
      "events": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动提醒"])},
      "calculators": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["工具箱"])},
      "settings": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("common.settings", undefined, _type)])}
    },
    "category": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["抽卡模拟"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通用工具"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限时活动"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["奇奇怪怪"])},
      
    ]
  },
  "image": {
    "getFont": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["获取「方正准雅宋 GBK」字体"])},
    "getFontDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["角色与灵犀名需要使用「方正准雅宋 GBK」字体，建议您使用安装有该字体的电脑访问本页。"])},
    "getFontConfirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["前往方正字库官网"])},
    "default": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["信使巡游"])},
      "flower": {
        "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["+1"])}
      }
    },
    "card": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵犀信息"])},
    "new": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["New"])},
    "sign": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["签名"])},
    "char": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["角色"])},
    "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["灵犀名"])},
    "star": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("level.star", undefined, _type)])},
    "second": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("level.second", undefined, _type)])},
    "flower": {
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["勿忘"])},
      "border": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["边框星级"])},
      "number": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["获得数量"])}
    },
    "mark": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["纪念标记"])},
    "marks": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["无"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["瑰意"])},
      
    ],
    "image": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["卡面"])},
    "imageDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将卡面手动裁剪为 宽:高=2:3 的比例，并依次将一段光影、二段光影（如果有）上传在此处。"])},
    "thumbDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请将卡面手动裁剪为 宽:高=1:1 的比例，并上传在此处，作为「勿忘」左下角的缩略图。"])},
    "generate": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["生成图片"])},
    "flowerDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["重复获得的灵犀将转换为对应灵犀品质提升道具"])}
  },
  "item": {
    "a": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设计师证明"])},
    "b": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["工艺学习"])},
    "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合成目标"])},
    "path": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["合成路线"])}
  },
  "level": {
    "double": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外婆小铺双倍"])},
    "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加灵犀"])},
    "need": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["仍需资源"])},
    "exp": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["经验"])},
    "plan": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["预计刷取"])},
    "planDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["刷取副本及其掉落内容按日常副本及其保底计。注意：外婆小铺 6-7 使用「重现五次」才有保底。"])},
    "遇见极光_5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["遇见极光 5"])},
    "遇见初心_5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["遇见初心 5"])},
    "遇见铭迹_5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["遇见铭迹 5"])},
    "外婆小铺_3_7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外婆小铺 3-7"])},
    "外婆小铺_6_7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["外婆小铺 6-7"])},
    "equal": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 灵感 = ", _interpolate(_list(1)), " ", _interpolate(_list(2))])},
    "sim": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 灵感 ≈ ", _interpolate(_list(1)), " ", _interpolate(_list(2))])},
    "sim2": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 灵感 ≈ ", _interpolate(_list(1)), " ", _interpolate(_list(2)), " + ", _interpolate(_list(3)), " ", _interpolate(_list(4))])},
    "card": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["灵犀 ", _interpolate(_list(0))])},
    "star": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星级"])},
    "rank": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开花"])},
    "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["等级"])},
    "break": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已突破"])},
    "skill": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["铭迹 ", _interpolate(_list(0))])},
    "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["养成目标"])},
    "second": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["二段光影"])}
  },
  "phone": {
    "wip": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本页面正在施工中，敬请期待！"])},
    "todo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["暂时还没有内容。"])},
    "tabbar": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发现"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["视频"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通讯录"])},
      
    ],
    "pages": [
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["发现"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discover"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["视频"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facetime"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通讯录"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["短信"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Message"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["朋友圈"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moments"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["树洞时刻"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Secrets"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["头像"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Avatar"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通讯录"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts"])},
        
      ],
      
    ],
    "message": {
      "types": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize([])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["[语音] "])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["[通话] "])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["[图片] "])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["[红包] "])},
        
      ],
      "calls": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["通话完成，点击回放"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["未接来电，点击回拨"])},
        
      ],
      "recentFormat": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), _interpolate(_list(1))])},
      "top": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["置顶"])},
      "hide": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["隐藏"])}
    },
    "video": {
      "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["其实这里是设置页！"])},
      "leave": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["离开"])}
    },
    "contact": {
      "avatar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["头像"])},
      "current": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前"])},
      "name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["昵称"])},
      "categories": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["特别好友"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["好友"])},
        
      ],
      "special": (ctx) => {const { normalize: _normalize, linked: _linked, type: _type } = ctx;return _normalize([_linked("phone.contact.categories[0]", undefined, _type)])},
      "level": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["好感度"])},
      "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["好感度等级进度 (%)"])},
      "add": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["添加到最近信息"])},
      "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["设置为主控视角"])},
      "clear": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["清空聊天记录"])},
      "delete": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["删除联系人"])}
    },
    "secret": {
      "tags": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["八卦来了"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["甄情实感"])},
        
      ]
    },
    "desc": {
      "mark": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具不提供四叶草标志的设置选项。如有需要，可在昵称后加 [🌱☘️🍀] 等 Emoji 来替代。"])}
    },
    "dialog": {
      "back": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["为防止误操作，要退出此页面，请前往 [视频] 选项卡。"])},
      "leave": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退出后，所有输入的内容都不会被保存。若要保留您的创作内容，请导出 JSON 并将其妥善保存。您确定要退出吗？"])},
      "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["您导入的内容有误，请检查是否将保存的内容完全导入。"])},
      "confirm": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["您确定要", _interpolate(_list(0)), "吗？"])}
    }
  },
  "statement": {
    "title": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["关于"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["声明"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["后事…？"])},
      
    ],
    "content": [
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["这是北极光工作室手机游戏《光与夜之恋》相关小工具集合，包含各类计算器与抽卡模拟器。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["欢迎大家使用，如果认为好用，欢迎随意分享；如果有任何想法、建议、希望添加的功能，或者发现了任何 bug，欢迎到 GitHub 提 issue、pull request 或者到我的微博提出。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具并未对宽屏幕进行优化，除非单独说明，建议您在移动设备上竖屏使用本工具，以获得较好的显示效果。"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具为玩家为爱发电产物，目前分支仅由一人维护。非官方，且与任何其他玩家组织无关。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具数据均来自官方公示，需手动同步更新，可能存在更新延迟、数据错误、跑路等风险，请以游戏中实际情况为准。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具中所引用的游戏资源，包括但不限于图片、文本等，仅用于表现游戏内容与增强用户体验，其版权属于北极光工作室。"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["本工具在 GitHub 平台以 MIT 协议开源，原始项目不会商用。"])},
        
      ],
      [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["如果我突然跑路了，GitHub 仓库大概率会依然保留。如果您了解 Vue 并且愿意接手屎山代码，欢迎您通过 clone、fork 等方式参与后续维护更新。"])},
        
      ],
      
    ],
    "weibo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["作者微博"])},
    "repo": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["GitHub 仓库"])}
  },
  "wish": {
    "target": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["目标抽数"])},
    "preset": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " 抽"])},
    "presets": {
      "64": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀"])},
      "68": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 1 花"])},
      "72": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 2 花"])},
      "76": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 3 花"])},
      "80": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 4 花"])},
      "88": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 4 花 + 1 个星辰馈赠"])},
      "95": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["限定灵犀 + 4 花 + 2 个星辰馈赠"])},
      "99": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["所有转盘和进度奖励（含限定灵犀 + 5 花）"])}
    },
    "presetDesc": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["保底：", _interpolate(_list(0))])},
    "hint": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["若计算还未开始的活动，只需改动「持有永久星愿瓶」。"])},
    "nextMinigame": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星雾谜戏"])},
    "nextMinigameDesc": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["打开「星雾谜戏」活动界面，将下图中「??」处出现的数字填写在此处。"])},
    "freeHad": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["持有限时星愿瓶"])},
    "paidHad": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["持有永久星愿瓶"])},
    "shop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「星星驿站」星愿瓶剩余库存"])},
    "wished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已许愿次数"])},
    "calendar": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["活动开始日期"])},
    "dailyBought": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已购买今日 2 北极星「每日星愿瓶」"])},
    "packBought": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已购买本次 9 北极星「星愿瓶礼盒」"])},
    "lost": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错过限时星愿瓶"])},
    "result": {
      "title": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["项目"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["抽数"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["北极星"])},
        
      ],
      "type": [
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["免费获取"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["付费获取"])},
        (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小计"])},
        
      ],
      "minigame": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「星雾谜戏」活动"])},
      "shop": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「星星驿站」兑换"])},
      "progress": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["「羁梦星愿」进度奖励"])},
      "current": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前持有"])},
      "lost": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["错过的星愿瓶"])},
      "daily": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["每日星愿瓶"])},
      "pack": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["星愿瓶礼盒"])},
      "direct": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["原价购买"])},
      "total": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["小计"])}
    },
    "dateFormat": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["M 月 D 日"])}
  },
  "wishsim": {
    "gacha": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["许愿"])},
    "complete": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["恭喜您 ", _interpolate(_list(0)), " 次许愿获得全部", _interpolate(_list(1)), "！"])},
    "possibility": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), "概率"])},
    "possibilityTitle": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["奖品"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["当前出率"])},
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["剩余"])},
      
    ],
    "possibilityDesc": [
      (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["除了「恋心」数目无限外，其余奖励全部获得后，其概率会均摊增加到其余奖励上。"])},
      (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["若 3 颗球同时落入浅色区域，则可以随机获取 1 份「", _interpolate(_list(0)), "」且不会重复。"])},
      
    ],
    "resultTitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["恭喜获得"])},
    "gachaTime": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已许愿次数"])},
    "gachaTimeDesc": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["/ ", _interpolate(_list(0)), " / ", _interpolate(_list(1)), " / ", _interpolate(_list(2)), " 抽各有一次保底"])},
    "giftTime": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["(第 ", _interpolate(_list(0)), " 抽)　"])},
    "giftNumber": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize([_interpolate(_list(0)), " × ", _interpolate(_list(1))])},
    "settings": {
      "maxFrame": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["动画速度"])},
      "maxFrames": {
        "216": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["慢慢速"])},
        "144": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["慢速"])},
        "72": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["中速"])},
        "36": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["快速"])},
        "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["光速"])}
      },
      "weight": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["奖品权重"])}
    },
    "notify": {
      "success": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["恭喜获得", _interpolate(_list(0)), "！"])},
      "protect": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, list: _list } = ctx;return _normalize(["您已经许愿 ", _interpolate(_list(0)), " 次，获得", _interpolate(_list(1)), "！"])}
    }
  }
}